import React from 'react';
import './InsightSection.css';

const InsightSection = () => {
  return (
    <section className="insight-section">
      {/* Imagen decorativa flotante */}
      <div className="insight-section__visual" />

      {/* Contenido */}
      <div className="insight-section__container">
        <div className="insight-section__text">
          <span className="insight-section__eyebrow">
            Invescasa Analytics turns data into direction.
          </span>

          <h2 className="insight-section__headline">
            By combining your goals with deep market data, we reveal
            opportunities in context, helping you make informed,
            strategic property decisions with confidence.
          </h2>
        </div>
      </div>
    </section>
  );
};

export default InsightSection;